// extracted by mini-css-extract-plugin
export default {"TabsBar":"w3p54kk6W1_hc677f4zO","Tab":"gqkjE4TyEOiBjHZVPZXg"};